import React from 'react';
import Loader from 'react-loader-spinner';
import Link from 'next/link';

const PageLoading = () => (
  <div className='pageLoading flex h-screen items-center justify-center cmr c-page-loading'>
    <div />
  </div>
);

export default PageLoading;
